export const updateUrlSearchParams = (navigate, updates, { replace = true } = {}) => {
  const url = new URL(window.location.href);

  Object.entries(updates).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") {
      url.searchParams.delete(key);
    } else {
      url.searchParams.set(key, String(value));
    }
  });

  navigate(`${url.pathname}${url.search}`, { replace });
};

export const parsePageParam = (params, defaultPage = 1) => {
  const page = Number(params?.page);
  return Number.isFinite(page) && page > 0 ? page : defaultPage;
};

export const parseSearchParam = (params) => params?.search || null;

export const parseFloorParam = (params, defaultFloor = 0) => {
  if (params?.floor === undefined || params?.floor === null || params?.floor === "") {
    return defaultFloor;
  }
  const floor = Number(params.floor);
  return Number.isFinite(floor) && floor >= 0 ? floor : defaultFloor;
};

export const getReturnToParam = () =>
  `${window.location.pathname}${window.location.search}`;

/**
 * Navigate to a patient page while remembering the list to come back to.
 *
 * The origin is kept in history state rather than the query string — encoding a
 * whole path into `?returnTo=` made URLs unreadable. history.state survives
 * reloads, so Back still restores the list's filters and page.
 */
export const navigateToPatientIp = (navigate, pathWithQuery) => {
  const url = new URL(pathWithQuery, window.location.origin);
  navigate(`${url.pathname}${url.search}`, {
    state: { returnTo: getReturnToParam() },
  });
};

export const resolveReturnTo = (returnTo) => {
  if (!returnTo || typeof returnTo !== "string") return null;
  try {
    const decoded = decodeURIComponent(returnTo);
    // Only allow same-origin relative paths
    if (!decoded.startsWith("/") || decoded.startsWith("//")) return null;
    return decoded;
  } catch {
    return null;
  }
};
